<div class="modal-background" bdFxLayoutAlign="center start" (click)="onModalClicked()">
    <div class="projects-modal" [ngClass]="{'force-full-height': !isInitialized }">
        <div bdFxLayoutAlign="space-between center" class="header">
            <div bdFxFlex bdFxLayoutAlign="start center" class="cancel">
                <!--                <button (click)="onCancelBtnClicked()" type="button">Abbrechen</button>-->
            </div>
            <div bdFxFlex bdFxLayoutAlign="center center" class="title">Zusammenfassung</div>
            <div bdFxFlex bdFxLayoutAlign="end center" class="save">
                <button class="bd-blue-button" (click)="onCancelBtnClicked()" type="button">
                    Schließen
                </button>
            </div>
        </div>
        <div class="divider"></div>
        <div class="scroll-area" (scroll)="onScroll()" *ngIf="dialogModel" #scrollArea>
            <div class="body">
<!--                <div class="app-merchant-user-info-viewer-container">-->
<!--                    <app-merchant-user-info-viewer></app-merchant-user-info-viewer>-->
<!--                    <div class="divider"></div>-->
<!--                </div>-->
                <div class="step6">
                    <app-projects-dialog-step6-sections-controller [usePriceApprovalMode]="usePriceApprovalMode">
                    </app-projects-dialog-step6-sections-controller>
                </div>
            </div>

            <div class="footer">
                <ng-container *ngIf="isActivePriceApprovalMode() else defaultButtons">
                    <button type="button" (click)="onPriceDenyBtnClicked()" class="btn-summary-secondary">
                        Preise ablehnen
                    </button>
                    <button type="button" (click)="onPriceConfirmBtnClicked()">
                        Preise freigeben
                    </button>
                </ng-container>

                <ng-template #defaultButtons>
                    <div class="divider"></div>
                    <button type="button" (click)="onCancelBtnClicked()">
                        Schließen
                    </button>
                </ng-template>

            </div>
        </div>

    </div>
</div>
